const webmRecorder = {
    analyser: undefined,
    mediaRecorder: undefined,
    endRecording: undefined,
    audioContext: undefined,
    isChrome: false,
    isFirefox: false,

    init(audioContext, source, stream, analyser) {
        this.analyser = analyser;
        this.audioContext = audioContext;

        var ua = window.navigator.userAgent.toLowerCase();
        this.isChrome = (ua.indexOf('chrome') >= 0 && ua.indexOf('edg') === -1);
        this.isFirefox = (ua.indexOf('firefox') > 0);

        try {
            this.mediaRecorder = new MediaRecorder(stream);
            this.mediaRecorder.ondataavailable = this.handleDataAvailable.bind(this);
        } catch (e) {
            alert('Exception while creating MediaRecorder!');
        }
    },
    record() {
        if (this.mediaRecorder && !(this.mediaRecorder.state == 'recording'))
            this.mediaRecorder.start();
    },
    stop(endRecording) {
        this.endRecording = endRecording;

        if (this.mediaRecorder && this.mediaRecorder.state == 'recording')
            this.mediaRecorder.stop();
    },
    handleDataAvailable(event) {
        if (event.data && event.data.size > 0) {
            const blob = new Blob([event.data], {type: 'audio/mp3'}); // or { 'type' : 'audio/ogg; codecs=opus' }

            if (this.endRecording)
                this.endRecording(blob);
        }
    },
    microphoneLevel() {
        var array = new Uint8Array(this.analyser.frequencyBinCount);
        this.analyser.getByteFrequencyData(array);

        return this.getAverageVolume(array);
    },
    getAverageVolume(array) {
        var values = 0;
        var average;
        var i;
        var length = array.length;

        // get all the frequency amplitudes
        for (i = 0; i < length; i++) {
            values += array[i];
        }

        average = values / length;

        return average;
    },
    cancelStream() {
        if (this.stream) {
            if (this.isChrome || this.isFirefox) {
                this.stream.getAudioTracks()[0].stop();
            } else {
                this.stream.stop();
            }

            this.stream = null;

            if (this.audioContext.close) {
                this.audioContext.close();
            } else {
                this.audioContext = null;
            }
        }
    }
};

export default webmRecorder;



/** WEBPACK FOOTER **
 ** ./src/components/utils/WebmRecorder.js
 **/